export const getCookies = () =>
  document.cookie.split(';').reduce((current, next) => {
    let key = next.slice(0, next.indexOf('=')).trim(),
      val = next.includes('=') ? next.slice(next.indexOf('=') + 1).trim() : '';
    current[key] = val;
    return current;
  }, {});

export const setCookies = (update = {}) =>
  Object.entries(update)
    .filter(([key, val]) => typeof key !== 'undefined' || typeof val !== 'undefined')
    .map(([key, val]) => `${key}=${val};path=/;`)
    .forEach(cookie => (document.cookie = cookie));

export const getCookie = key => getCookies()[key];
export const setCookie = (key, value) => setCookies(Object.assign(getCookies(), { [key]: value }));
export const cookieExists = (key, value) => getCookie(key) === value;

export default getCookies;
